"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentStateToJSON = exports.EnrollmentStateFromJSONTyped = exports.EnrollmentStateFromJSON = exports.EnrollmentState = void 0;
/**
 * The state of Enrollment
 * @export
 * @enum {string}
 */
var EnrollmentState;
(function (EnrollmentState) {
    EnrollmentState["BACKGROUNDCHECKBYPASSED"] = "BACKGROUND_CHECK_BYPASSED";
    EnrollmentState["BACKGROUNDCHECKCOMPLETED"] = "BACKGROUND_CHECK_COMPLETED";
    EnrollmentState["BACKGROUNDCHECKINPROGRESS"] = "BACKGROUND_CHECK_IN_PROGRESS";
    EnrollmentState["ENROLLMENTCOMPLETED"] = "ENROLLMENT_COMPLETED";
    EnrollmentState["ENROLLMENTINPROGRESS"] = "ENROLLMENT_IN_PROGRESS";
    EnrollmentState["FINGERPRINTRESUBMISSIONSENT"] = "FINGERPRINT_RESUBMISSION_SENT";
    EnrollmentState["FINGERPRINTRESUBMISSIONFAILURE"] = "FINGERPRINT_RESUBMISSION_FAILURE";
    EnrollmentState["FINGERPRINTUNKNOWNFAILURE"] = "FINGERPRINT_UNKNOWN_FAILURE";
    EnrollmentState["INITIAL"] = "INITIAL";
    EnrollmentState["PREENROLLMENTCOMPLETED"] = "PRE_ENROLLMENT_COMPLETED";
    EnrollmentState["PREENROLLMENTINPROGRESS"] = "PRE_ENROLLMENT_IN_PROGRESS";
    EnrollmentState["PURGED"] = "PURGED";
    EnrollmentState["TSAADJUDICATIONINPROGRESS"] = "TSA_ADJUDICATION_IN_PROGRESS";
    EnrollmentState["TSAAPPLICATIONSUBMITTED"] = "TSA_APPLICATION_SUBMITTED";
    EnrollmentState["TSAFINALDETERMINATION"] = "TSA_FINAL_DETERMINATION";
    EnrollmentState["TSAAPPROVED"] = "TSA_APPROVED";
    EnrollmentState["TSADENIED"] = "TSA_DENIED";
    EnrollmentState["TSAPAYMENTPROCESSED"] = "TSA_PAYMENT_PROCESSED";
    EnrollmentState["TSAPAYMENTSENT"] = "TSA_PAYMENT_SENT";
    EnrollmentState["TSARAPBACKSUBMITTED"] = "TSA_RAPBACK_SUBMITTED";
    EnrollmentState["WAITINGONFINGERPRINTRECAPTURE"] = "WAITING_ON_FINGERPRINT_RECAPTURE";
    EnrollmentState["WAITINGONTSABIOMETRICS"] = "WAITING_ON_TSA_BIOMETRICS";
    EnrollmentState["ENROLLMENTCANCELLED"] = "ENROLLMENT_CANCELLED";
    EnrollmentState["INVALIDCLEAR"] = "INVALID_CLEAR";
    EnrollmentState["INVALIDTSA"] = "INVALID_TSA";
})(EnrollmentState = exports.EnrollmentState || (exports.EnrollmentState = {}));
function EnrollmentStateFromJSON(json) {
    return EnrollmentStateFromJSONTyped(json, false);
}
exports.EnrollmentStateFromJSON = EnrollmentStateFromJSON;
function EnrollmentStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EnrollmentStateFromJSONTyped = EnrollmentStateFromJSONTyped;
function EnrollmentStateToJSON(value) {
    return value;
}
exports.EnrollmentStateToJSON = EnrollmentStateToJSON;
//# sourceMappingURL=EnrollmentState.js.map